import LoginLogo from './LoginLogo.svg'
import EmailImage from './EmailIcon.svg'
import PasswordImage from './PasswordIcon.svg'
export const LoginRuminTechLogo = LoginLogo
export const EmailIcon = EmailImage
export const PasswordIcon = PasswordImage
